import { GET_ARTIST_BY_ID, GET_ARTISTS } from "../actions/ActionTypes";
const initialState = {
  data: [],
  page: 1,
  total: 0,
  totalPages: 0,
  isLoading: true,
};
const initial = false;
function ArtistReducer(state = initialState, actions) {
  if (actions.type === GET_ARTISTS) {
    return {
      ...state,
      ...actions.payload,
    };
  }
  if (actions.type === GET_ARTIST_BY_ID) {
    return {
      ...state,
      artistDetails: actions.payload, // ✅ store artist details
    };
  }
  if (
    actions.type === "LOADING" &&
    (actions.payload.action_model === GET_ARTISTS ||
      actions.payload.action_model === GET_ARTIST_BY_ID)
  ) {
    return {
      ...state,
      isLoading: actions.payload.loading,
    };
  }
  return state;
}

export { ArtistReducer };
